export const AD_INTERACTIONS_KEY = 'sponsoredAdInteractions';
export const INTERACTION_MONITOR_INTERVAL_MS = 10000; // 10s
export const PROCESS_INTERACTIONS_DELAY_MS = 3000; // 3s